module.exports = __webpack_public_path__ + "static/media/Drywall.b5d7a410.jpeg";